// CommonAccessSitesImages
import COMMON_ACCESS_SITES_LARGE_1 from '../assets/HowToImages/CommonAccessSitesImages/largeDeviceGifs/step1.gif';
import COMMON_ACCESS_SITES_LARGE_2 from '../assets/HowToImages/CommonAccessSitesImages/largeDeviceGifs/step2.gif';
import COMMON_ACCESS_SITES_LARGE_3 from '../assets/HowToImages/CommonAccessSitesImages/largeDeviceGifs/step3.gif';
import COMMON_ACCESS_SITES_SMALL_1 from '../assets/HowToImages/CommonAccessSitesImages/smallDeviceGifs/step1.gif';
import COMMON_ACCESS_SITES_SMALL_2 from '../assets/HowToImages/CommonAccessSitesImages/smallDeviceGifs/step2.gif';
import COMMON_ACCESS_SITES_SMALL_3 from '../assets/HowToImages/CommonAccessSitesImages/smallDeviceGifs/step3.gif';

// dropDownAndPorts
import DROP_PORT_LARGE_DROPDOWN_CONTROLLER from '../assets/HowToImages/dropDownAndPorts/largeDeviceGifs/dropDownFromController.gif';
import DROP_PORT_LARGE_DROPDOWN_LEO from '../assets/HowToImages/dropDownAndPorts/largeDeviceGifs/dropDownFromLeo.gif';
import DROP_PORT_LARGE_PORTS_CONTROLLER from '../assets/HowToImages/dropDownAndPorts/largeDeviceGifs/portsFromController.gif';
import DROP_PORT_LARGE_PORTS_LEO from '../assets/HowToImages/dropDownAndPorts/largeDeviceGifs/portsFromLeo.gif';
import DROP_PORT_SMALL_DROPDOWN_CONTROLLER from '../assets/HowToImages/dropDownAndPorts/smallDeviceGifs/dropDownFromController.gif';
import DROP_PORT_SMALL_DROPDOWN_LEO from '../assets/HowToImages/dropDownAndPorts/smallDeviceGifs/dropDownFromLeo.gif';
import DROP_PORT_SMALL_PORTS_CONTROLLER from '../assets/HowToImages/dropDownAndPorts/smallDeviceGifs/portsFromController.gif';
import DROP_PORT_SMALL_PORTS_LEO from '../assets/HowToImages/dropDownAndPorts/smallDeviceGifs/portsFromLeo.gif';

// EditReportingPrefsImages
import EDIT_REPORT_LARGE_STEP1 from '../assets/HowToImages/EditReportingPrefsImages/largeDeviceGifs/step1.gif';
import EDIT_REPORT_LARGE_STEP2 from '../assets/HowToImages/EditReportingPrefsImages/largeDeviceGifs/step2.gif';
import EDIT_REPORT_LARGE_STEP3 from '../assets/HowToImages/EditReportingPrefsImages/largeDeviceGifs/step3.gif';
import EDIT_REPORT_LARGE_STEP4 from '../assets/HowToImages/EditReportingPrefsImages/largeDeviceGifs/step4.gif';
import EDIT_REPORT_LARGE_STEP5 from '../assets/HowToImages/EditReportingPrefsImages/largeDeviceGifs/step5.gif';
import EDIT_REPORT_LARGE_STEP6 from '../assets/HowToImages/EditReportingPrefsImages/largeDeviceGifs/step6.gif';
import EDIT_REPORT_LARGE_STEP7 from '../assets/HowToImages/EditReportingPrefsImages/largeDeviceGifs/step7.png';
import EDIT_REPORT_LARGE_STEP8 from '../assets/HowToImages/EditReportingPrefsImages/largeDeviceGifs/step8.gif';
import EDIT_REPORT_SMALL_STEP1 from '../assets/HowToImages/EditReportingPrefsImages/smallDeviceGifs/step1.gif';
import EDIT_REPORT_SMALL_STEP2 from '../assets/HowToImages/EditReportingPrefsImages/smallDeviceGifs/step2.gif';
import EDIT_REPORT_SMALL_STEP3 from '../assets/HowToImages/EditReportingPrefsImages/smallDeviceGifs/step3.gif';
import EDIT_REPORT_SMALL_STEP4 from '../assets/HowToImages/EditReportingPrefsImages/smallDeviceGifs/step4.gif';
import EDIT_REPORT_SMALL_STEP5 from '../assets/HowToImages/EditReportingPrefsImages/smallDeviceGifs/step5.gif';
import EDIT_REPORT_SMALL_STEP6 from '../assets/HowToImages/EditReportingPrefsImages/smallDeviceGifs/step6.gif';
import EDIT_REPORT_SMALL_STEP7 from '../assets/HowToImages/EditReportingPrefsImages/smallDeviceGifs/step7.png';
import EDIT_REPORT_SMALL_STEP8 from '../assets/HowToImages/EditReportingPrefsImages/smallDeviceGifs/step8.gif';

// HowToAccessLeoImages
import ACCESS_LEO_LARGE_STEP4 from '../assets/HowToImages/HowToAccessLeoImages/largeDeviceGifs/step4.gif';
import ACCESS_LEO_SMALL_STEP4 from '../assets/HowToImages/HowToAccessLeoImages/smallDeviceGifs/step4.gif';

// HowToAccessTerminalModeImages
import ACCESS_TERM_LARGE_STEP4 from '../assets/HowToImages/HowToAccessTerminalModeImages/largeDeviceGifs/step4.gif';
import ACCESS_TERM_LARGE_STEP5 from '../assets/HowToImages/HowToAccessTerminalModeImages/largeDeviceGifs/step5.gif';
import ACCESS_TERM_LARGE_STEP6 from '../assets/HowToImages/HowToAccessTerminalModeImages/largeDeviceGifs/step6.gif';
import ACCESS_TERM_SMALL_STEP4 from '../assets/HowToImages/HowToAccessTerminalModeImages/smallDeviceGifs/step4.gif';
import ACCESS_TERM_SMALL_STEP5 from '../assets/HowToImages/HowToAccessTerminalModeImages/smallDeviceGifs/step5.gif';
import ACCESS_TERM_SMALL_STEP6 from '../assets/HowToImages/HowToAccessTerminalModeImages/smallDeviceGifs/step6.gif';
import ACCESS_TERM_SMALL_STEP7 from '../assets/HowToImages/HowToAccessTerminalModeImages/smallDeviceGifs/step7.gif';
import { HowToStepsImageFolder } from '../components/Modals/Constants';

type FolderKey =
  | 'CommonAccessSitesImages'
  | 'dropDownAndPorts'
  | 'EditReportingPrefsImages'
  | 'HowToAccessLeoImages'
  | 'HowToAccessTerminalModeImages';

type DeviceType = 'large' | 'small';

const imageMap: Record<
  FolderKey,
  Record<DeviceType, Record<string, string>>
> = {
  CommonAccessSitesImages: {
    large: {
      'step1.gif': COMMON_ACCESS_SITES_LARGE_1,
      'step2.gif': COMMON_ACCESS_SITES_LARGE_2,
      'step3.gif': COMMON_ACCESS_SITES_LARGE_3,
    },
    small: {
      'step1.gif': COMMON_ACCESS_SITES_SMALL_1,
      'step2.gif': COMMON_ACCESS_SITES_SMALL_2,
      'step3.gif': COMMON_ACCESS_SITES_SMALL_3,
    },
  },
  dropDownAndPorts: {
    large: {
      'dropDownFromController.gif': DROP_PORT_LARGE_DROPDOWN_CONTROLLER,
      'dropDownFromLeo.gif': DROP_PORT_LARGE_DROPDOWN_LEO,
      'portsFromController.gif': DROP_PORT_LARGE_PORTS_CONTROLLER,
      'portsFromLeo.gif': DROP_PORT_LARGE_PORTS_LEO,
    },
    small: {
      'dropDownFromController.gif': DROP_PORT_SMALL_DROPDOWN_CONTROLLER,
      'dropDownFromLeo.gif': DROP_PORT_SMALL_DROPDOWN_LEO,
      'portsFromController.gif': DROP_PORT_SMALL_PORTS_CONTROLLER,
      'portsFromLeo.gif': DROP_PORT_SMALL_PORTS_LEO,
    },
  },
  EditReportingPrefsImages: {
    large: {
      'step1.gif': EDIT_REPORT_LARGE_STEP1,
      'step2.gif': EDIT_REPORT_LARGE_STEP2,
      'step3.gif': EDIT_REPORT_LARGE_STEP3,
      'step4.gif': EDIT_REPORT_LARGE_STEP4,
      'step5.gif': EDIT_REPORT_LARGE_STEP5,
      'step6.gif': EDIT_REPORT_LARGE_STEP6,
      'step7.png': EDIT_REPORT_LARGE_STEP7,
      'step8.gif': EDIT_REPORT_LARGE_STEP8,
    },
    small: {
      'step1.gif': EDIT_REPORT_SMALL_STEP1,
      'step2.gif': EDIT_REPORT_SMALL_STEP2,
      'step3.gif': EDIT_REPORT_SMALL_STEP3,
      'step4.gif': EDIT_REPORT_SMALL_STEP4,
      'step5.gif': EDIT_REPORT_SMALL_STEP5,
      'step6.gif': EDIT_REPORT_SMALL_STEP6,
      'step7.png': EDIT_REPORT_SMALL_STEP7,
      'step8.gif': EDIT_REPORT_SMALL_STEP8,
    },
  },
  HowToAccessLeoImages: {
    large: {
      'step4.gif': ACCESS_LEO_LARGE_STEP4,
    },
    small: {
      'step4.gif': ACCESS_LEO_SMALL_STEP4,
    },
  },
  HowToAccessTerminalModeImages: {
    large: {
      'step4.gif': ACCESS_TERM_LARGE_STEP4,
      'step5.gif': ACCESS_TERM_LARGE_STEP5,
      'step6.gif': ACCESS_TERM_LARGE_STEP6,
    },
    small: {
      'step4.gif': ACCESS_TERM_SMALL_STEP4,
      'step5.gif': ACCESS_TERM_SMALL_STEP5,
      'step6.gif': ACCESS_TERM_SMALL_STEP6,
      'step7.gif': ACCESS_TERM_SMALL_STEP7,
    },
  },
};

export function getImageSrc(
  filename: string,
  folderName: HowToStepsImageFolder,
  isSmallDevice: boolean,
): string {
  const deviceKey: DeviceType = isSmallDevice ? 'small' : 'large';
  const folder = imageMap[folderName];
  if (!folder) throw new Error(`Unknown folder name: ${folderName}`);
  const deviceMap = folder[deviceKey];
  if (!deviceMap) throw new Error(`Unknown device type: ${deviceKey}`);
  const image = deviceMap[filename];
  if (!image)
    throw new Error(
      `Image not found: ${filename} in ${folderName} (${deviceKey})`,
    );

  return image;
}
